import React from "react";
import TheNav from "./components/nav";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import HomePage from "./pages/index";
import Profile from "./pages/profile";
import errPage from "./pages/err";
import About from "./pages/about";
class App extends React.Component {
  render() {
    return (
      <div className="App">
        <Router>
          <TheNav />
          <div className="container">
            <Switch>
              <Route path="/" exact component={HomePage} />
              <Route path="/profile/:login" component={Profile} />
              <Route path="/about" component={About} />
              <Route component={errPage} />
            </Switch>
          </div>
        </Router>
      </div>
    );
  }
}

export default App;
